import { useEffect, useState } from 'react';
import { Card, Typography, Space, Tag, Spin } from 'antd';
import { useBitrix } from '../../context/BitrixContext';

const { Title, Text } = Typography;

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const PERMISSION_GROUPS = [
    {
        title: 'Удостоверения',
        items: [
            { key: 'canAddCertificates', label: 'Добавление' },
            { key: 'canViewCertificates', label: 'Просмотр' },
            { key: 'canEditCertificates', label: 'Редактирование' },
            { key: 'canDeleteCertificates', label: 'Удаление' },
        ],
    },
    {
        title: 'Объекты',
        items: [
            { key: 'canAddObjects', label: 'Добавление' },
            { key: 'canViewObjects', label: 'Просмотр' },
            { key: 'canEditObjects', label: 'Редактирование' },
            { key: 'canDeleteObjects', label: 'Удаление' },
        ],
    },
    {
        title: 'Оборудование',
        items: [
            { key: 'canAddEquipments', label: 'Добавление' },
            { key: 'canViewEquipments', label: 'Просмотр' },
            { key: 'canEditEquipments', label: 'Редактирование' },
            { key: 'canDeleteEquipments', label: 'Удаление' },
        ],
    },
    {
        title: 'Теги',
        items: [
            { key: 'canEditTags', label: 'Изменение' },
        ],
    },
    {
        title: 'Настройки',
        items: [
            { key: 'canChangeSettings', label: 'Изменение настроек' },
            { key: 'canChangePermissions', label: 'Изменение прав' },
        ],
    },
    {
        title: 'Администрирование',
        items: [
            { key: 'isAdmin', label: 'Администратор' },
        ],
    },
];

const MyProfile = () => {
    const { user, auth } = useBitrix();
    const [permissions, setPermissions] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!user || !auth) return;
        let isMounted = true;
        setLoading(true);
        fetch(`${API_URL}/permissions/me`, {
            headers: {
                'X-Bitrix-User': user.ID,
                'X-Bitrix-Auth': auth,
            },
        })
            .then((res) => (res.ok ? res.json() : null))
            .then((data) => {
                if (!isMounted) return;
                setPermissions(data || {});
            })
            .finally(() => {
                if (!isMounted) return;
                setLoading(false);
            });

        return () => {
            isMounted = false;
        };
    }, [user, auth]);

    if (!user) return null;

    const fullName = [user.NAME, user.LAST_NAME].filter(Boolean).join(' ');

    return (
        <Card>
            <Title level={3} style={{ marginTop: 0 }}>
                Мой профиль
            </Title>

            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <div>
                    <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>Имя пользователя:</Text>
                    <Text style={{ fontSize: 16 }}>{fullName || 'Без имени'}</Text>
                </div>

                <div>
                    <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>Права:</Text>
                    {loading ? (
                        <Spin size="small" />
                    ) : (
                        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                            {PERMISSION_GROUPS.map((group) => {
                                const activeItems = group.items.filter((item) => permissions?.[item.key]);
                                if (activeItems.length === 0) return null;

                                return (
                                    <div key={group.title}>
                                        <Text style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>
                                            {group.title}
                                        </Text>
                                        <Space size={[8, 8]} wrap>
                                            {activeItems.map((item) => (
                                                <Tag key={item.key} color="blue">
                                                    {item.label}
                                                </Tag>
                                            ))}
                                        </Space>
                                    </div>
                                );
                            })}
                            {permissions && PERMISSION_GROUPS.every((group) => group.items.every((item) => !permissions?.[item.key])) && (
                                <Text type="secondary">Нет активных прав</Text>
                            )}
                        </Space>
                    )}
                </div>
            </Space>
        </Card>
    );
};

export default MyProfile;
